import { render, staticRenderFns } from "./right-bar.vue?vue&type=template&id=f34c67fc&"
import script from "./right-bar.vue?vue&type=script&lang=js&"
export * from "./right-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f34c67fc')) {
      api.createRecord('f34c67fc', component.options)
    } else {
      api.reload('f34c67fc', component.options)
    }
    module.hot.accept("./right-bar.vue?vue&type=template&id=f34c67fc&", function () {
      api.rerender('f34c67fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/right-bar.vue"
export default component.exports